exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2.nomAffaire[data-v-cd23ef38]:before {\n    content: \"affaire\";\n    font-size: 12px;\n    display: block;\n    color: #dedede;\n    letter-spacing: 4px;\n}\nh2.numAffaire[data-v-cd23ef38] {\n  margin-top: 5px;\n  font-size: 16px;\n}\nh2.numAffaire[data-v-cd23ef38]:before {\n    content: \"num\\E9ro affaire\";\n    font-size: 12px;\n    display: block;\n    color: #dedede;\n    letter-spacing: 4px;\n}\n#gestmensuelle[data-v-cd23ef38] {\n  zoom: 0.931!important;\n}\n", ""]);

// exports
